export const E_FORM_GENERATION_REQUEST = 'E_FORM_GENERATION_REQUEST';
export const E_FORM_GENERATION_SUCCESS = 'E_FORM_GENERATION_SUCCESS';
export const E_FORM_GENERATION_ERROR = 'E_FORM_GENERATION_ERROR';

export const E_FORM_GENERATION_RESET = 'E_FORM_GENERATION_RESET';

export const EFORM_DOWNLOAD_REQUEST = 'EFORM_DOWNLOAD_REQUEST';
export const EFORM_DOWNLOAD_SUCCESS = 'EFORM_DOWNLOAD_SUCCESS';
export const EFORM_DOWNLOAD_ERROR = 'EFORM_DOWNLOAD_ERROR';
